/**
 * File: Accordion.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v1.0.1
 * Created: 2025-08-17
 * Last Updated: 2026-01-01
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Icons
import { FaPlus } from "react-icons/fa6";
import { FaMinus } from "react-icons/fa6";

/**
 * [TODO: Component description here]
 *
 * @param {Object} props - Component properties
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function Accordion({ panelID, header, content, isActive, onToggle }) {
    return (
        <>
            <div className="accordion">
                <button
                    className="accordion__button"
                    onClick={() => onToggle(panelID)}
                >
                    <div className="accordion__header">
                        <p className="accordion__text">{header}</p>
                        <span className="accordion__icon">
                            {isActive ? <FaMinus /> : <FaPlus />}
                        </span>
                    </div>
                </button>
                <div
                    className={`accordion__panel ${
                        isActive ? "accordion__panel--active" : ""
                    }`}
                    id={panelID}
                >
                    <p>{content}</p>
                </div>
            </div>
        </>
    );
}

export default Accordion;
